module.exports = __webpack_public_path__ + "img/D201508_4.e47b4646.jpg";